import { ActionTypes } from './userDataReducerNew';

// Action Creators
export const setRobotClients = (robots) => ({
  type: ActionTypes.SET_ROBOT_CLIENTS,
  payload: robots,
});

export const setUserRobotsData = (data) => ({
  type: ActionTypes.SET_USER_ROBOTS_DATA,
  payload: data,
});

export const setUserOrgsData = (data) => ({
  type: ActionTypes.SET_USER_ORGS_DATA,
  payload: data,
});

export const setRobotConnected = (robotData) => ({
  type: ActionTypes.SET_ROBOT_CONNECTED,
  payload: robotData,
});

export const setRobotDisconnected = (robotData) => ({
  type: ActionTypes.SET_ROBOT_DISCONNECTED,
  payload: robotData,
});

export const updateRobotClientData = (robot_client_id, updated_data) => ({
  type: ActionTypes.UPDATE_ROBOT_CLIENT_DATA,
  payload: { "robot_client_id": robot_client_id, 
              "updated_data": updated_data 
            },
});
